<template>
  <v-container
    fluid
    class="grey lighten-5 fill-height"
  >
    <v-layout column>
      <v-flex>
        <CardsLine
          header="Archived"
          :data="this.$store.state.included"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import CardsLine from '../components/CardsLine';

export default {
  name: 'Archive',
  components: {
    CardsLine
  },
  computed: {
    archived() {
      return this.$store.state.recent.filter(item => item.archive === true);
    }
  },    
};
</script>


<style scoped>
</style>
